import { Delete, Edit } from '@/shared/icons'

import type { TableAction } from './types'

export type EditDeleteCommand = 'edit' | 'delete'

/**
 * The row menu of a plain CRUD table — configure the record, or delete it — ready for
 * `TableActions`' `actions`. Reach for it rather than writing the pair out: the delete
 * entry has three properties (divided, danger, the wording) that have to agree across every
 * such table.
 *
 * `editLabel` for a table that says "Edit" rather than "Configure"; `deleteVisible` for a
 * row that may not be deleted at all.
 */
export function editDeleteActions(
  options: {
    editLabel?: string
    deleteLabel?: string
    deleteVisible?: boolean
  } = {}
): TableAction<EditDeleteCommand>[] {
  return [
    { command: 'edit', label: options.editLabel ?? 'Configure', icon: Edit },
    {
      command: 'delete',
      label: options.deleteLabel ?? 'Delete',
      icon: Delete,
      divided: true,
      danger: true,
      visible: options.deleteVisible
    }
  ]
}
